import JwtService from './jwtService'

export default function useJwt(axiosIns, jwtOverrideConfig, authCallback = () => {}) {
  const jwt = new JwtService(axiosIns, jwtOverrideConfig, authCallback)

  return {
    jwt,
  }
}
